var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlook24Px = function SvgOutlook24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0072C6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.511 9.588c-.467 0-.84.22-1.115.659-.275.439-.413 1.02-.413 1.743 0 .733.138 1.313.413 1.74.275.427.636.64 1.082.64.46 0 .826-.208 1.095-.623.27-.415.405-.99.405-1.727 0-.768-.13-1.365-.393-1.792-.262-.426-.62-.64-1.074-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 20.315V3.479L13.807 1v22L1 20.315Zm6.453-4.503c.87 0 1.576-.357 2.117-1.07.541-.711.813-1.65.812-2.814 0-1.133-.261-2.045-.784-2.738-.521-.692-1.205-1.038-2.05-1.038-.895 0-1.614.362-2.157 1.085-.543.723-.814 1.67-.814 2.841 0 1.109.268 2.008.802 2.699.534.69 1.225 1.035 2.074 1.035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.617 9.967V5.664h7.388c.272 0 .754.37.754.887l-6.472 4.363a.387.387 0 0 1-.166 0l-1.503-.947Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.99 12.516-1.373-.943v5.849h6.972c.62 0 1.17-.361 1.17-1.222V8.29s-6.38 4.24-6.349 4.23c-.037.02-.245.125-.42-.004Z"
  }))));
};
export default SvgOutlook24Px;